<template>
  <div id="CreateClaimClaimInfo" class="row bg-light pb-3 pt-8">
    <div class="col"> 
      <h1>Invoice Information</h1>
      <table class="table table-striped invoiceTable">
        <tr>
          <td>Contact Name</td>
          <td>{{ claimDto.ContactName }}</td> 
        </tr>
        <tr>
          <td>Contact Email</td>
          <td>{{ claimDto.ContactEmail }}</td>
        </tr>
        <tr>
          <td>Invoice Source</td>
          <td>{{ claimDto.InvoiceSource }}</td>
        </tr>
        <tr>
          <td>Invoice Number</td>
          <td>{{ claimDto.InvoiceNumber }}</td>
        </tr>
        <tr>
          <td>Invoice Date</td>
          <td>{{ claimDto.InvoiceDate }}</td>
        </tr>
        <tr>
          <td>Order Number</td>
          <td>{{ claimDto.OrderNumber }}</td>
        </tr>
        <tr>
          <td>Freight Invoiced</td>
          <td>${{ claimDto.InvoiceFreight }}</td>
        </tr>
      </table>
      <h3 style="margin-left: 12px;">
        Expected Freight Credit:
      </h3>
      <!-- TODO: make this be a money-input only  -->
      <DnNumberInput
        id="freightPriceCustomerSaysItShouldHaveBeen"
        v-model="claimDto.FreightExpectedCredit"
        :class="[{ borderError: showCreditValidation && claimDto.FreightExpectedCredit < minFreightCredit,
                   borderSuccess: showCreditValidation && claimDto.FreightExpectedCredit >= minFreightCredit}]"
        name="freightPriceCustomerSaysItShouldHaveBeen"
        :allow-negatives="false"
        :min-number="minFreightCredit"
        :allow-decimals="true"
        v-validate="'required|min_value:' + minFreightCredit"
      />
    </div>

    <div class="col" style="padding-top: 56px;">
      <div class="row no-gutters">
        <label><strong>Comments:</strong></label>
        <b-form-textarea
          v-model="claimDto.FreightComment"
          v-validate="{required: true, min: freightCommentMin, max: freightCommentMax}"
          :class="[{ borderError: showCommentValidation && IsNotNullOrUndefined(claimDto,'FreightComment.length') && parseInt(claimDto.FreightComment.length) < freightCommentMin,
               borderSuccess: showCommentValidation && IsNotNullOrUndefined(claimDto,'FreightComment.length') && parseInt(claimDto.FreightComment.length) >= freightCommentMin}]"
          :name="'Comments'"
          rows="11"
          max-rows="11"
          maxlength="250"
        />
        <div>
          <small>{{ claimDto.FreightComment.length }} / 250 characters</small>
        </div>
        <div v-if="showCommentValidation && IsNotNullOrUndefined(claimDto,'FreightComment.length') && parseInt(claimDto.FreightComment.length) < freightCommentMin" class="colorError">
          Comment length must be between {{ freightCommentMin }} and {{ freightCommentMax }} characters.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ClaimsService } from "@/services/ClaimsService"
  import { stringHelper } from "@/components/mixins/stringHelper"
  import { inputValidateState } from "@/components/mixins/inputValidateState"
  import { claimReasonPopover } from "@/components/mixins/ClaimReasonPopover"
  import {constants} from "@/const"
  import DnNumberInput from "@/components/Elements/DnNumberInput"

  export default {
    components: {
      DnNumberInput
    },
    mixins: [stringHelper, inputValidateState, claimReasonPopover, constants],

    props: {
      claimDto: {
        type: Object,
        default: () => ({})
      },
      validationState: {
        type: Object,
        default: () => ({}),
        freightClaimInfoTab: { type: Boolean, default: false }
      }
    },

    data: () => ({
      showCommentValidation: false,
      showCreditValidation: false,
      freightCommentMin: 5,
      freightCommentMax: 250,
      minFreightCredit: 0.01
    }),
    // Since there are several inputs to validate, using `updated` to loop through all
    // inputs to check valid state whenever the page changes.
    updated () {
      this.$validator.validateAll().then((result) => {
        this.validationState.freightClaimInfoTab = result
      })
    }
    
  }
</script>

<style>
#freightPriceCustomerSaysItShouldHaveBeen{
  width: 250px;
  margin-left: 12px;
}

.borderSuccess{
  border: 2px solid green !important;
}

.borderError{
  border: 2px solid red !important;
}

.colorError{
  color: red;
}

.invoiceTable{
  width: 260px;
  margin: 12px;
}
</style>